import { render, staticRenderFns } from "./ExcelEdit.vue?vue&type=template&id=640ca80c&scoped=true&"
import script from "./ExcelEdit.vue?vue&type=script&lang=js&"
export * from "./ExcelEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExcelEdit.vue?vue&type=style&index=0&id=640ca80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ca80c",
  null
  
)

export default component.exports